export default __webpack_public_path__ + "bc3d43359a09cd2de3261cc01c843f21.png";